// 该文件专门用于创建整个应用的路由器
import Router from 'vue-router'
import axios from 'axios'
import { getToken} from '../utils/auth'
import routes from './routes'//所有的路由数据
// import { from } from 'core-js/core/array'


// 创建并暴露路由器,均是需要登录权限的路由
const router = new Router({
    base:'/classifreadingb/',//"/classifreadingb/",//nginx前端访问的根目录
    mode: 'history',
    routes: routes
})
// 全局前置路由守卫
router.beforeEach((to, from, next) => {
    console.log('to:', to, 'from:', from)
    if (to.meta.isAuth) {//判断是否需要鉴权
        if (getToken("account")) {
            next()//放行
            
        } else {
            alert('无权查看')
        }
    } else {
        next()
    }
})
// router.afterEach((to,from)=>{

// })
// router.beforeEach((to,from,next)=>{
//     console.log("to.path:",to.path)
//     if(!getToken("Token")){
//         console.log('11111')

//     }else{
//         console.log('222')
//       // 如果没有token,请求后台

//     }  
//   })


// 暴露
export default router
